import { resourceApi } from "@utils/interceptors";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);
export async function searchService(endpoint, page, limit, tipo, stato, sort={'_id': -1}, search, initial_filters, filtri){  
  let filters = !filtri?{}:filtri
    if (stato && typeof stato !== 'object') filters["stato"] = stato
    if(stato && typeof stato === 'object') filters = {...filters, ...stato}
    if (tipo) filters["tipo"] = tipo
    const payload = {"query":{},"sort":sort,"search":search?search:'',"page":page,"limit":limit,"filters":filters,"initial_filters":{}}
    return await resourceApi.post(`/search${endpoint}`, JSON.stringify(payload));
}
export function dateFormatter(date, format='DD/MM/YY', expected_format){
    if (typeof date === 'number'){
      date=date.toString()
    }
    if (expected_format){
      return dayjs(date||new Date(),expected_format).format(format)
    }
    return dayjs(date||new Date()).format(format);
}

// Interpreta in modo permissivo un valore data: Date, epoch (ms), ISO/`YYYY-MM-DD`
// e i formati italiani `DD/MM/YYYY`, `DD-MM-YYYY` (anche con anno a 2 cifre).
// Restituisce `null` se il valore non è una data valida.
export function parseDateValue(date){
    if (date === null || date === undefined || date === '') return null;
    if (date instanceof Date) return dayjs(date).isValid() ? dayjs(date) : null;
    if (typeof date === 'number') return dayjs(date).isValid() ? dayjs(date) : null;
    const value = String(date).trim();
    if (!value) return null;
    // Un formato esplicito ha priorità: "12/05/1990" per dayjs sarebbe 5 dicembre.
    if (!/^\d{4}-\d{1,2}-\d{1,2}/.test(value)){
        for (const expected of ['DD/MM/YYYY','DD-MM-YYYY','DD/MM/YY','DD-MM-YY']){
            const parsed = dayjs(value, expected);
            if (parsed.isValid()) return parsed;
        }
    }
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
}

// 'YYYY-MM-DD', l'unico formato accettato da <input type="date">.
// '' quando il valore non è una data valida (mai "Invalid Date" nel DOM).
export function toInputDate(date){
    const parsed = parseDateValue(date);
    return parsed ? parsed.format('YYYY-MM-DD') : '';
}

// 'YYYY-MM-DDTHH:mm:ss' (ora locale, senza fuso) per il backend.
// '' quando il valore non è una data valida (mai "Invalid Date" sulla rete).
export function toServerDate(date){
    const parsed = parseDateValue(date);
    return parsed ? parsed.format('YYYY-MM-DDTHH:mm:ss') : '';
}
export function random(length,text_only) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    if(!text_only) characters+= '0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }
 export const getCookie = (name) => {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, cookieValue] = cookie.trim().split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  };
  export function setCookie (name, value)  {
    document.cookie = `${name}=${value}`;
  }
export function setStoredRedirectUrl(url) {
  localStorage.setItem('redirectUrl', url);
}
export function consumeRedirectUrl() {
  const url = localStorage.getItem('redirectUrl');
  localStorage.removeItem('redirectUrl');
  return url;
}
export function transactionFormatter(transaction){
    return (transaction / 100).toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '€';
}
export function paymentState(paymentState){
    return paymentState==='sospesa'?'Sospesa':paymentState==='inattivo'?'Inattiva':paymentState==='utenza_annullata'?'Annullata':paymentState === 'unpaid'?'Non pagata':paymentState==='paid'?'Pagata':paymentState==='processing'?'In lavorazione':paymentState==='iniziata'?'Iniziata':paymentState==='conclusa'?'Conclusa':paymentState==='attiva'?'Attiva':paymentState==='eliminata'?'Eliminata': paymentState==='annullata'?'Annullata':paymentState==='tutte'?'Tutto':paymentState==='contestata'?'Contestata':paymentState==='insolvente'?'Insolvente':paymentState==='fallita'?'Fallita':paymentState==='attivo'?'Attivo':paymentState==='sospeso'?'Sospeso':paymentState==='inattivo'?'Inattivo':paymentState==='attesa_pagamento'?'In attesa di pagamento':paymentState==='utenza_annullata'?'Annullata da princpiale':'Insoluta'

}

// Tempo massimo di attesa dell'evento socket `pagamento:<id>:status` prima di
// recuperare lo stato del pagamento via REST (fallback).
export const PAYMENT_STATUS_TIMEOUT_MS = 30000;

// Fallback REST: recupera lo stato di un pagamento direttamente dall'entity.
// Usato quando l'evento socket non arriva entro PAYMENT_STATUS_TIMEOUT_MS.
// Normalizza la risposta in un oggetto con `payment_status` coerente con il socket.
export async function getPaymentStatus(paymentId){
    if (!paymentId) return null;
    const entity = await resourceApi.get(`/entity/pagamenti/${paymentId}`);
    if (!entity) return null;
    const payment_status = entity.payment_status || entity.stato;
    const errore = entity.credit_management?.errore_pagamento;
    const intent = entity.payment_intent_data;
    const normalized = {
        ...entity,
        payment_status,
        // Il backend usa `stato: "requires_action"` con i dati 3DS in `payment_intent_data`.
        requires_action: entity.requires_action || payment_status === 'requires_action' || !!intent,
    };
    if (intent) {
        normalized.payment_intent = intent.payment_intent;
        normalized.payment_method = intent.payment_method;
        normalized.stripe_account = intent.stripe_account;
    }
    if (!normalized.reason) normalized.reason = errore?.FailureMessage || errore?.FailureCode;
    return normalized;
}

// Stati "in lavorazione" (carta): il pagamento non è ancora terminale, va ritentato.
export const PAYMENT_PENDING_STATUSES = ['processing','pending','in_corso','in_lavorazione','in_attesa','attesa_pagamento'];

// SDD / SEPA Direct Debit: il gateway conferma l'addebito con lo stato "pending",
// che per l'SDD è un BUON FINE (l'addebito si completa nei giorni bancari successivi).
// "processing" non è uno stato valido per l'SDD.
export const SDD_SUCCESS_STATUSES = ['paid','pending'];

// Stati ancora "in lavorazione" per l'SDD: né "pending" (buon fine) né "processing".
export const SDD_PENDING_STATUSES = ['in_corso','in_lavorazione','in_attesa','attesa_pagamento'];

// Intervallo tra due GET di fallback quando lo stato è ancora "in lavorazione".
export const PAYMENT_STATUS_POLL_INTERVAL_MS = 10000;

// Numero massimo di tentativi di polling del fallback.
export const PAYMENT_STATUS_MAX_ATTEMPTS = 6;

// Stati "in lavorazione" validi per il metodo di pagamento.
export function isPendingPaymentStatus(status, paymentMethod){
    if (paymentMethod === 'sdd') return SDD_PENDING_STATUSES.includes(status);
    return PAYMENT_PENDING_STATUSES.includes(status);
}

// Buon fine del pagamento: per l'SDD anche "pending" (addebito nei giorni bancari).
export function isPaymentSuccessful(status, paymentMethod){
    if (paymentMethod === 'sdd') return SDD_SUCCESS_STATUSES.includes(status);
    return status === 'paid';
}

// Compone un messaggio comprensibile per un pagamento fallito, usando la lista
// `errori_stripe` di app_settings (nessun testo hardcoded), a partire dal codice/
// messaggio dell'errore presente sull'entity o nei dati del socket.
export function paymentFailureMessage(data, appSettings){
    const err = data?.credit_management?.errore_pagamento;
    const code = err?.FailureCode || data?.failure_code;
    const raw = err?.FailureMessage || data?.reason || data?.failure_message || '';
    const list = (Array.isArray(appSettings) && appSettings.find(e => e?._id === 'errori_stripe')?.data) || [];
    const byId = (id) => list.find(e => e?.id === id);

    // 1) match esatto sul codice d'errore
    if (code && byId(code)) return byId(code).value;
    // 2) match esatto sul messaggio (comportamento storico di CreditCard)
    if (raw && byId(raw)) return byId(raw).value;

    // 3) l'id di un errore (es. "insufficient_funds") è riconoscibile dentro il
    //    messaggio Stripe (es. "Your card has insufficient funds.")
    const message = String(raw).toLowerCase().replace(/_/g, ' ');
    if (message) {
        const match = list.find(e => e?.id && message.includes(String(e.id).toLowerCase().replace(/_/g, ' ')));
        if (match) return match.value;
    }
    return raw || 'Pagamento non riuscito. Riprova o usa un\'altra carta.';
}
